let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lLMmr")).then(() => parcelRequire('1fqqM'));